export enum OfferSituation {
	Bought = 'Comprado',
	Offered = 'Ofertado',
	Cotacao = 'Cotação',
}
